/**
 * @generated SignedSource<<e33bea861eb67237b9982e216fac0550>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectSurveysPageQuery$variables = {
  portfolioPath: string;
  projectPath: string;
  teamPath: string;
};
export type ProjectSurveysPageQuery$data = {
  readonly pqiUser: {
    readonly authUser: {
      readonly " $fragmentSpreads": FragmentRefs<"ProjectSurveyCard_user">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectSurveysEmptyState_pqiUser" | "useIsProjectAdmin_pqiUser">;
  } | null | undefined;
  readonly team: {
    readonly portfolio: {
      readonly project: {
        readonly __typename: string;
        readonly budget: {
          readonly amount: Intl.StringNumericLiteral;
        } | null | undefined;
        readonly projectCategory: {
          readonly id: string;
        } | null | undefined;
        readonly responsiblePerson: {
          readonly id: string;
        } | null | undefined;
        readonly surveys: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"ProjectSurveyCard_survey">;
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"ProjectSurveyCard_project" | "ProjectSurveysEmptyState_project" | "useIsProjectAdmin_project">;
      } | null | undefined;
    } | null | undefined;
    readonly projectCategories: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectSurveyCard_team">;
  } | null | undefined;
};
export type ProjectSurveysPageQuery = {
  response: ProjectSurveysPageQuery$data;
  variables: ProjectSurveysPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "portfolioPath"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectPath"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamPath"
},
v3 = [
  {
    "kind": "Variable",
    "name": "path",
    "variableName": "teamPath"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectCategory",
  "kind": "LinkedField",
  "name": "projectCategories",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "path",
    "variableName": "portfolioPath"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "path",
    "variableName": "projectPath"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "responsiblePerson",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectCategory",
  "kind": "LinkedField",
  "name": "projectCategory",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = [
  (v9/*: any*/),
  (v4/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectSurveysPageQuery",
    "selections": [
      {
        "alias": "team",
        "args": (v3/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByPath",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProjectSurveyCard_team"
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "portfolio",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useIsProjectAdmin_project"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProjectSurveysEmptyState_project"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProjectSurveyCard_project"
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectSurvey",
                    "kind": "LinkedField",
                    "name": "surveys",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ProjectSurveyCard_survey"
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectBudget",
                    "kind": "LinkedField",
                    "name": "budget",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PQiUser",
        "kind": "LinkedField",
        "name": "pqiUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useIsProjectAdmin_pqiUser"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProjectSurveysEmptyState_pqiUser"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "authUser",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProjectSurveyCard_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectSurveysPageQuery",
    "selections": [
      {
        "alias": "team",
        "args": (v3/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByPath",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSurveyTemplate",
            "kind": "LinkedField",
            "name": "projectSurveyTemplates",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "questionIds",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "portfolio",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isProjectInterface"
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pricingModel",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "portfolio",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isPortfolio"
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "team",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "parent",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "parent",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v4/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "parent",
                                            "plural": false,
                                            "selections": (v14/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "SubPortfolio",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "SubPortfolio",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "SubPortfolio",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectBudget",
                    "kind": "LinkedField",
                    "name": "budget",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "isReceivedProject",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SharedProjectDetails",
                        "kind": "LinkedField",
                        "name": "sharedProjectDetails",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamBasicInfo",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ReceivedProject",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "acceptedTermsAndConditions",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "surveySender",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Project",
                    "abstractKey": null
                  },
                  (v9/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": "rawId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "originalId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "path",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "questionnaire",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectSurvey",
                    "kind": "LinkedField",
                    "name": "surveys",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "surveyNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "surveyDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timeZone",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "closedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DataSheet",
                        "kind": "LinkedField",
                        "name": "dataSheet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "responseRate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "respondentCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "responseCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "commentCount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "surveyTemplateId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecipientList",
                        "kind": "LinkedField",
                        "name": "recipientList",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CustomizedQuestionnaire",
                            "kind": "LinkedField",
                            "name": "customizedQuestionnaire",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "originalIndicatorIds",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "originalQuestionIds",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "recipientCount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resultsUnlocked",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectRawId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sentAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timeOfDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sender",
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PQiUser",
        "kind": "LinkedField",
        "name": "pqiUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PQiUserGrant",
            "kind": "LinkedField",
            "name": "grants",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "teamId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "portfolioId",
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "authUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "554aab9761054dbd6206db32be2e4f4b",
    "id": null,
    "metadata": {},
    "name": "ProjectSurveysPageQuery",
    "operationKind": "query",
    "text": "query ProjectSurveysPageQuery(\n  $projectPath: String!\n  $teamPath: String!\n  $portfolioPath: String!\n) {\n  team: teamByPath(path: $teamPath) {\n    ...ProjectSurveyCard_team\n    projectCategories {\n      id\n    }\n    portfolio(path: $portfolioPath) {\n      __typename\n      project(path: $projectPath) {\n        ...useIsProjectAdmin_project\n        ...ProjectSurveysEmptyState_project\n        ...ProjectSurveyCard_project\n        __typename\n        surveys {\n          ...ProjectSurveyCard_survey\n          id\n        }\n        responsiblePerson {\n          id\n        }\n        projectCategory {\n          id\n        }\n        budget {\n          amount\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  pqiUser {\n    ...useIsProjectAdmin_pqiUser\n    ...ProjectSurveysEmptyState_pqiUser\n    authUser {\n      ...ProjectSurveyCard_user\n      id\n    }\n    id\n  }\n}\n\nfragment ApproveDownloadDialog_survey on ProjectSurvey {\n  id\n  resultsUnlocked\n}\n\nfragment CloseProjectSurveyForm_survey on ProjectSurvey {\n  id\n  surveyNumber\n  status\n}\n\nfragment CloseSurveyAction_survey on ProjectSurvey {\n  surveyNumber\n  ...CloseProjectSurveyForm_survey\n}\n\nfragment DownloadPQiFeedbackButton_survey on ProjectSurvey {\n  projectRawId\n  surveyNumber\n  resultsUnlocked\n}\n\nfragment DownloadPQiSummaryOrQualityReportButton_survey on ProjectSurvey {\n  projectRawId\n  surveyNumber\n  resultsUnlocked\n  ...ApproveDownloadDialog_survey\n}\n\nfragment DownloadReportsPopupButton_project on ProjectInterface {\n  __isProjectInterface: __typename\n  name\n  team {\n    pricingModel\n    id\n  }\n}\n\nfragment DownloadReportsPopupButton_surveys on ProjectSurvey {\n  surveyDate\n  timeZone\n  resultsUnlocked\n  surveyNumber\n  dataSheet {\n    respondentCount\n    responseRate\n    responseCount\n    commentCount\n  }\n  ...DownloadPQiSummaryOrQualityReportButton_survey\n  ...DownloadPQiFeedbackButton_survey\n}\n\nfragment EditSurveyDateSurveyAction_survey on ProjectSurvey {\n  surveyNumber\n  ...EditSurveyEndDateForm_survey\n  ...CloseProjectSurveyForm_survey\n}\n\nfragment EditSurveyEndDateForm_survey on ProjectSurvey {\n  id\n  status\n  surveyNumber\n  surveyDate\n  endDate\n  timeZone\n}\n\nfragment ProjectSurveyCardCompletedSurvey_project on ProjectInterface {\n  __isProjectInterface: __typename\n  ...DownloadReportsPopupButton_project\n  __typename\n  id\n  rawId: originalId\n  path\n  questionnaire {\n    __typename\n    id\n  }\n  surveys {\n    surveyNumber\n    status\n    ...ReopenSurveyDialog_surveys\n    id\n  }\n}\n\nfragment ProjectSurveyCardCompletedSurvey_survey on ProjectSurvey {\n  id\n  surveyNumber\n  endDate\n  timeZone\n  closedAt\n  dataSheet {\n    responseRate\n    respondentCount\n    responseCount\n    commentCount\n  }\n  surveyTemplateId\n  recipientList {\n    customizedQuestionnaire {\n      originalIndicatorIds\n      originalQuestionIds\n    }\n    id\n  }\n  ...DownloadReportsPopupButton_surveys\n}\n\nfragment ProjectSurveyCardCompletedSurvey_team on Team {\n  id\n  projectSurveyTemplates {\n    id\n    name\n    questionIds\n  }\n}\n\nfragment ProjectSurveyCardCompletedSurvey_user on User {\n  ...useIsAdmin_user\n}\n\nfragment ProjectSurveyCardOngoingSurvey_project on ProjectInterface {\n  __isProjectInterface: __typename\n  __typename\n  name\n  id\n  rawId: originalId\n}\n\nfragment ProjectSurveyCardOngoingSurvey_survey on ProjectSurvey {\n  ...EditSurveyEndDateForm_survey\n  ...CloseSurveyAction_survey\n  ...EditSurveyDateSurveyAction_survey\n  id\n  surveyNumber\n  sentAt\n  endDate\n  timeZone\n  dataSheet {\n    responseRate\n    respondentCount\n    responseCount\n  }\n  recipientList {\n    recipientCount\n    id\n  }\n}\n\nfragment ProjectSurveyCardPlannedSurvey_survey on ProjectSurvey {\n  id\n  surveyNumber\n  surveyDate\n  timeOfDay\n  timeZone\n  endDate\n  status\n  sender\n}\n\nfragment ProjectSurveyCardPreliminarySurvey_survey on ProjectSurvey {\n  surveyNumber\n  surveyDate\n  timeZone\n  status\n}\n\nfragment ProjectSurveyCardQueuedSurvey_survey on ProjectSurvey {\n  id\n  projectId\n  projectRawId\n  surveyNumber\n  surveyDate\n  timeOfDay\n  timeZone\n  status\n}\n\nfragment ProjectSurveyCard_project on ProjectInterface {\n  __isProjectInterface: __typename\n  __typename\n  ...ProjectSurveyCardCompletedSurvey_project\n  ...ProjectSurveyCardOngoingSurvey_project\n}\n\nfragment ProjectSurveyCard_survey on ProjectSurvey {\n  status\n  ...ProjectSurveyCardCompletedSurvey_survey\n  ...ProjectSurveyCardOngoingSurvey_survey\n  ...ProjectSurveyCardPlannedSurvey_survey\n  ...ProjectSurveyCardPreliminarySurvey_survey\n  ...ProjectSurveyCardQueuedSurvey_survey\n}\n\nfragment ProjectSurveyCard_team on Team {\n  ...ProjectSurveyCardCompletedSurvey_team\n}\n\nfragment ProjectSurveyCard_user on User {\n  ...ProjectSurveyCardCompletedSurvey_user\n}\n\nfragment ProjectSurveysEmptyState_pqiUser on PQiUser {\n  ...useIsProjectAdmin_pqiUser\n}\n\nfragment ProjectSurveysEmptyState_project on ProjectInterface {\n  __isProjectInterface: __typename\n  ...useIsProjectAdmin_project\n  ...useIsProjectCreateComplete_project\n  __typename\n  ... on Project {\n    surveySender {\n      id\n    }\n  }\n  ... on ReceivedProject {\n    sharedProjectDetails {\n      team {\n        name\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment ReopenProjectSurveyForm_survey on ProjectSurvey {\n  id\n  status\n  surveyNumber\n  surveyDate\n  endDate\n}\n\nfragment ReopenSurveyDialog_surveys on ProjectSurvey {\n  surveyNumber\n  status\n  ...ReopenProjectSurveyForm_survey\n}\n\nfragment useIsAdmin_user on User {\n  emailAddress\n}\n\nfragment useIsGrantedToResource_portfolio on Portfolio {\n  __isPortfolio: __typename\n  id\n  team {\n    id\n  }\n  ... on SubPortfolio {\n    parent {\n      __typename\n      id\n      ... on SubPortfolio {\n        parent {\n          __typename\n          id\n          ... on SubPortfolio {\n            parent {\n              __typename\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useIsGrantedToResource_pqiUser on PQiUser {\n  grants {\n    role\n    teamId\n    portfolioId\n    projectId\n  }\n}\n\nfragment useIsGrantedToResource_project on ProjectInterface {\n  __isProjectInterface: __typename\n  id\n  team {\n    id\n  }\n  portfolio {\n    __typename\n    ...useIsGrantedToResource_portfolio\n    id\n  }\n}\n\nfragment useIsProjectAdmin_pqiUser on PQiUser {\n  ...useIsGrantedToResource_pqiUser\n}\n\nfragment useIsProjectAdmin_project on ProjectInterface {\n  __isProjectInterface: __typename\n  ...useIsGrantedToResource_project\n}\n\nfragment useIsProjectCreateComplete_project on ProjectInterface {\n  __isProjectInterface: __typename\n  team {\n    pricingModel\n    id\n  }\n  budget {\n    __typename\n  }\n  ... on ReceivedProject {\n    isReceivedProject: __typename\n  }\n  ... on Project {\n    subscription {\n      acceptedTermsAndConditions\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "277c632bf13ba6b2a5ac3577f3f8fdcd";

export default node;
